function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { Badge } from './Badge';
export function BadgeText(props) {
  var text = props.content,
      _props$type = props.type,
      type = _props$type === void 0 ? 'danger' : _props$type,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'top-right' : _props$placement,
      supCls = props.supCls,
      supStyle = props.supStyle,
      extra = _objectWithoutProperties(props, ["content", "type", "placement", "supCls", "supStyle"]);

  var cls = classnames(usePrefixCls('badge-text', {
    placement: placement
  }), usePrefixCls("badge-type-".concat(type)), supCls);
  var content = React.createElement("div", {
    className: cls,
    style: supStyle
  }, text);
  return React.createElement(Badge, Object.assign({
    content: content,
    placement: placement
  }, extra));
}